module.exports = __webpack_public_path__ + "assets/urendeclareren5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/urendeclareren5.jpg
// module id = 369
// module chunks = 0